module.exports = __webpack_public_path__ + "img/success-icon.c56d0fc5.png";